/* oxlint-disable import/no-unassigned-import */
import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2';

import { type UncefactUnitType } from '~/types/unit';

import { truncate } from '@vestigas/utils';
import { LOCALE_INFO } from '~/utils/l10n';
import { getAbbreviatedUnit } from '~/utils/unit';

const defaultChartData = {
  datasets: [],
  labels: [],
};

type ChartData = {
  datasets: Array<{
    backgroundColor: string[];
    data: number[];
  }>;
  labels: string[];
};

type P = {
  readonly chartData: ChartData;
  readonly selectedUnit?: UncefactUnitType;
} & ComponentStyling;

export const DoughnutChart = ({
  chartData = defaultChartData,
  className,
  selectedUnit,
  style,
}: P) => {
  const options = {
    cutout: '56%',
    elements: {
      arc: {
        borderColor: 'white',
        hoverBorderColor: 'white',
      },
    },
    locale: LOCALE_INFO.name,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        boxPadding: 6,
        callbacks: {
          label({
            formattedValue,
            label,
          }: {
            formattedValue: string;
            label: string;
          }) {
            const abbreviatedUnit = getAbbreviatedUnit(selectedUnit);
            const valueAndUnit = [formattedValue, abbreviatedUnit]
              .filter(Boolean)
              .join(' ')
              .trim();

            const key = truncate(
              label?.replace(/\s+/g, ' ').trim(), // remove unnecessary spaces
              26 - valueAndUnit.length,
              5,
            );

            return `${key}: ${valueAndUnit}`;
          },
          title([{ label }]) {
            return truncate(label, 26, 5);
          },
        },
        padding: {
          x: 10,
          y: 8,
        },
      },
    },
  };

  return (
    <Doughnut
      className={className}
      data={chartData}
      options={options}
      style={style}
    />
  );
};
